import { __assign, __awaiter, __generator } from "tslib";
import _ from 'lodash';
import { dashify } from '@wix/wix-vod-shared/dist/src/common/utils/guid';
import { VIDEO_APP_DEF_ID } from '@wix/wix-vod-constants/dist/common/app-def-id';
import { addResources, createPlanBenefits, deleteResources, list, update, deletePlanBenefits, } from '@wix/ambassador-pricing-plans-v2-benefit/http';
import { BenefitType, } from '@wix/ambassador-pricing-plans-v2-benefit/types';
import { getEligibleOrders } from '@wix/ambassador-pricing-plans-v2-member-benefit/http';
import { getPlan } from '@wix/ambassador-pricing-plans-v2-plan/http';
var PricingPlansAPI = /** @class */ (function () {
    function PricingPlansAPI(httpClient) {
        this.httpClient = httpClient;
    }
    PricingPlansAPI.prototype.configBenefit = function (resourceIds, benefitId) {
        var id = benefitId ? { id: benefitId } : {};
        return __assign({ benefitType: BenefitType.UNLIMITED, resourceIds: resourceIds }, id);
    };
    PricingPlansAPI.prototype.connectChannelToPlan = function (planId, channelId) {
        return __awaiter(this, void 0, void 0, function () {
            var benefit, resourceId, benefitId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBenefitWithPlanInfo(planId)];
                    case 1:
                        benefit = (_a.sent()).benefit;
                        resourceId = dashify(channelId);
                        if (!benefit) return [3 /*break*/, 3];
                        benefitId = benefit === null || benefit === void 0 ? void 0 : benefit.id;
                        return [4 /*yield*/, this.httpClient.request(addResources({
                                resources: [
                                    {
                                        planId: planId,
                                        benefitId: benefitId,
                                        resourceId: resourceId,
                                    },
                                ],
                            }))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.createPlanBenefit(planId, [resourceId])];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PricingPlansAPI.prototype.createPlanBenefit = function (planId, resourceIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request(createPlanBenefits({
                            planId: planId,
                            appDefId: VIDEO_APP_DEF_ID,
                            benefits: [this.configBenefit(resourceIds, null)],
                        }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PricingPlansAPI.prototype.disconnectChannelFromPlan = function (planId, channelId) {
        return __awaiter(this, void 0, void 0, function () {
            var benefit, benefitId, resourceId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBenefitWithPlanInfo(planId)];
                    case 1:
                        benefit = (_a.sent()).benefit;
                        benefitId = benefit === null || benefit === void 0 ? void 0 : benefit.id;
                        resourceId = dashify(channelId);
                        return [4 /*yield*/, this.httpClient.request(deleteResources({
                                linkedResources: {
                                    benefitId: benefitId,
                                    planId: planId,
                                    resourceIds: [resourceId],
                                },
                            }))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PricingPlansAPI.prototype.getBenefits = function () {
        return __awaiter(this, void 0, void 0, function () {
            var benefitsWithPlanInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request(list({
                            appDefIds: [VIDEO_APP_DEF_ID],
                        }))];
                    case 1:
                        benefitsWithPlanInfo = (_a.sent()).data.benefitsWithPlanInfo;
                        return [2 /*return*/, benefitsWithPlanInfo || []];
                }
            });
        });
    };
    PricingPlansAPI.prototype.getBenefitWithPlanInfo = function (planId) {
        return __awaiter(this, void 0, void 0, function () {
            var benefitsWithPlanInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request(list({
                            appDefIds: [VIDEO_APP_DEF_ID],
                            planIds: [planId],
                        }))];
                    case 1:
                        benefitsWithPlanInfo = (_a.sent()).data.benefitsWithPlanInfo;
                        return [2 /*return*/, benefitsWithPlanInfo && benefitsWithPlanInfo.length
                                ? benefitsWithPlanInfo[0]
                                : {}];
                }
            });
        });
    };
    PricingPlansAPI.prototype.getConnectedPlansIds = function (channelId) {
        return __awaiter(this, void 0, void 0, function () {
            var plans;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getConnectedPlans(channelId)];
                    case 1:
                        plans = _a.sent();
                        return [2 /*return*/, plans.map(function (_a) {
                                var id = _a.id;
                                return id;
                            })];
                }
            });
        });
    };
    PricingPlansAPI.prototype.getConnectedPlans = function (channelId) {
        return __awaiter(this, void 0, void 0, function () {
            var resourceId, benefitsWithPlanInfo, plans;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resourceId = dashify(channelId);
                        return [4 /*yield*/, this.httpClient.request(list({
                                appDefIds: [VIDEO_APP_DEF_ID],
                                resourceIds: [resourceId],
                            }))];
                    case 1:
                        benefitsWithPlanInfo = (_a.sent()).data.benefitsWithPlanInfo;
                        plans = _.map(benefitsWithPlanInfo, function (_a) {
                            var planInfo = _a.planInfo;
                            return planInfo;
                        });
                        return [2 /*return*/, _.uniqBy(plans, 'id')];
                }
            });
        });
    };
    PricingPlansAPI.prototype.getPlan = function (planId) {
        return __awaiter(this, void 0, void 0, function () {
            var plan;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request(getPlan({
                            id: planId,
                        }))];
                    case 1:
                        plan = (_a.sent()).data.plan;
                        return [2 /*return*/, plan];
                }
            });
        });
    };
    PricingPlansAPI.prototype.overwritePlanChannels = function (planId, channelIds) {
        return __awaiter(this, void 0, void 0, function () {
            var benefit;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBenefitWithPlanInfo(planId)];
                    case 1:
                        benefit = (_a.sent()).benefit;
                        if (!benefit) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.httpClient.request(update({
                                planId: planId,
                                appDefId: VIDEO_APP_DEF_ID,
                                benefits: [this.configBenefit(channelIds, benefit.id)],
                            }))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.createPlanBenefit(planId, channelIds)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PricingPlansAPI.prototype.removeChannelFromAllPlans = function (channelId) {
        return __awaiter(this, void 0, void 0, function () {
            var resourceId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resourceId = dashify(channelId);
                        return [4 /*yield*/, this.httpClient.request(deleteResources({
                                resourceIds: {
                                    resourceIds: [resourceId],
                                },
                            }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PricingPlansAPI.prototype.removePlanBenefit = function (planId) {
        return __awaiter(this, void 0, void 0, function () {
            var benefit;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBenefitWithPlanInfo(planId)];
                    case 1:
                        benefit = (_a.sent()).benefit;
                        if (!benefit) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.httpClient.request(deletePlanBenefits({
                                planId: planId,
                                benefitIds: [benefit.id],
                            }))];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PricingPlansAPI.prototype.hasAccessToChannel = function (channelId, contactId) {
        return __awaiter(this, void 0, void 0, function () {
            var memberOrdersByPlan;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request(getEligibleOrders({
                            contactId: contactId,
                            resourceId: channelId,
                            appDefId: VIDEO_APP_DEF_ID,
                            targetDate: new Date(),
                        }))];
                    case 1:
                        memberOrdersByPlan = (_a.sent()).data.memberOrdersByPlan;
                        return [2 /*return*/, Boolean(memberOrdersByPlan === null || memberOrdersByPlan === void 0 ? void 0 : memberOrdersByPlan.length)];
                }
            });
        });
    };
    return PricingPlansAPI;
}());
export { PricingPlansAPI };
//# sourceMappingURL=pricing-plans-api.js.map